/*
 *
 * SelectGridField constants
 *
 */

export const EXECUTE_EDIT_ACTION = 'claris-vnext/AdvancedForm/SelectGridField/EXECUTE_EDIT_ACTION';
export const DOCUMENTS_DX_GRID = 'DocumentsDxGrid';

